import { api } from './client';
import type { AmbushableAttack, AttackRequest, AttackResult } from '../types/attack';

export async function launchAttack(
  worldId: string,
  provinceId: string,
  request: AttackRequest
): Promise<AttackResult> {
  const response = await api.post<{ attack: AttackResult }>(`/api/worlds/${worldId}/provinces/${provinceId}/attack`, {
    attackType: request.attackType,
    targetProvinceId: request.targetProvinceId,
    generals: request.numberOfGenerals,
    soldiers: request.numberOfSoldiers,
    offenseSpecialists: request.numberOfOffenseSpecialists,
    elites: request.numberOfElites,
    warHorses: request.numberOfWarHorses,
    prisoners: request.numberOfPrisoners,
    mercenaries: request.numberOfMercenaries,
    // SF-96: only meaningful for AMBUSH; omitted (undefined) for every other attack type.
    sourceEventSeq: request.sourceEventSeq,
  });

  if (response.error) {
    throw new Error(response.error);
  }

  if (!response.data) {
    throw new Error('No data returned from attack');
  }

  return response.data.attack;
}

/**
 * SF-96 Component 9: lists the historical Traditional March attacks this province can still
 * Ambush. Display surface (PG-backed) — cache-busted on every poll, per the endpoint's
 * CacheControl.noCache().mustRevalidate() contract.
 */
export async function fetchAmbushableAttacks(
  worldId: string,
  provinceId: string
): Promise<AmbushableAttack[]> {
  const response = await api.get<AmbushableAttack[]>(
    `/api/worlds/${worldId}/provinces/${provinceId}/ambushable-attacks`
  );

  if (response.error) {
    throw new Error(response.error);
  }

  return response.data ?? [];
}
